import React, { useEffect, useState } from "react";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Pagination, Card, Row, Col} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaRegUserCircle} from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import AdminDashboard from "./admindashboard";
import EmployeeDetailsModal from "./employeeDetailsModal";

function EmployeeAccountApproval() {
  const [employeesDetails, setEmployeeDetails] = useState([]);
  const [loading, setLoading] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
const [currentPage, setCurrentPage] = useState(0);
const [totalPages, setTotalPages] = useState(0);
const [searchTerm, setSearchTerm] = useState("");
const [selectedUserid, setSelectedUserid] = useState(null);
const [isApproved, setIsApproved] = useState(false);
  const [companies, setCompanies] = useState([]);

  const [selectedCompany, setSelectedCompany] = useState("all");

const token = JSON.parse(localStorage.getItem("data")).token;

  const navigate = useNavigate();
  useEffect(() => {
    if (searchTerm || selectedCompany !== "all") {
      searchData(0);  
    } else {
      getData(currentPage);   
  }
  }, [searchTerm, selectedCompany, currentPage]); 

 
 const searchData = async (pageNumber = 0) => {
     setLoading(true);
     try {
      const searchUrl = `/api/employeedetails/searchByCompanyOrNameOrEmail`;
               const requestData = {
                 searchTerm,
                 companyId:selectedCompany === "all" ? null : selectedCompany,
               };
         
       const response = await axios.post(searchUrl, requestData, {
         params: { page: pageNumber, disabled:true },
         headers: { Authorization: `Bearer ${token}` },
       });
       setEmployeeDetails(response.data.content);
       setCurrentPage(response.data.number);
       setTotalPages(response.data.totalPages);
      setLoading(false);

    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };
  const getData = async (pageNumber = 0) => {
    setLoading(true);
    try { 
         const compRes = await axios.get("/api/companydetails/getCompanies", {
                headers: { Authorization: `Bearer ${token}` },
              });
              setCompanies(compRes.data); 
      const trans = await axios.get(`/api/employeedetails/getAllEmployees/disabled=true`, {
        params: { page: pageNumber }, 
        headers: { Authorization: `Bearer ${token}` },
      });
  
      setEmployeeDetails(trans.data.content);
      setCurrentPage(trans.data.number);
      setTotalPages(trans.data.totalPages);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  
    if (searchTerm.trim()) {
      searchData(newPage);
    } else {
      getData(newPage);
    }
  };
 
 
  const openProfileModal =async (userid) => {
    setSelectedUserid(userid);
    setIsModalOpen(true);
  };

  const handleCloseProfileModal = () => {
    setSelectedUserid(null);
    setIsModalOpen(false);
    getData();

  };

  const handleApprovalChange =async (e, userid) => {
    e.stopPropagation(); // Prevent triggering card's onClick
  
    const checked = e.target.checked;
  
    setIsApproved(checked); // if this is global, you may want to manage it per-user instead
    setLoading(true);
    try {
        const requestData = {
            disabled: !checked,
        userid: userid,
            
          };
      const response = await axios.post("/api/employeedetails/approve-account", requestData ,{
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoading(false);
     toast.success("Account Approved Successfully");
     getData();
    } catch (error) {
        setLoading(false);
     handleError(error);
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      }  else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      }
       else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  return (
    <div>
    <div>
        <AdminDashboard />
      </div>
    {loading && <div className="loading"></div>} 
    <div className="col-12 mx-xl-auto ps-xl-10 mt-10">
        <div className="card card-raised">
          <div className="card-body">
          <div className="card-title form-group d-flex align-items-center justify-content-between">
  <span>Employees Details</span>
</div>
<div>
  <div className="d-flex align-items-center" style={{ width: '100%' }}>
    {/* Filter by Company Dropdown */}
    <div className="d-flex align-items-center" style={{ width: 'auto', marginRight: '20px' }}>
      <label htmlFor="companyFilter" className="form-label mb-0" style={{ marginRight: '8px' }}>
        Filter by Company:
      </label>
      <select
        id="companyFilter"
        className="form-select"
        value={selectedCompany || "all"}
        onChange={(e) => setSelectedCompany(e.target.value)}
        style={{ width: '200px' }}
      >
        <option value="all">All Companies</option>
        {companies.map((company) => (
          <option key={company.id} value={company.id}>
            {company.companyname} ({company.companycode})
          </option>
        ))}
      </select>
    </div>

    {/* Search Input */}
    <div className="d-flex align-items-center" style={{ width: 'auto' }}>
      <div style={{ position: "relative", width: "250px" }}>
        <input
          type="text"
          className="form-control ps-14"
          placeholder="Search by Name or Email"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ paddingLeft: "30px" }}
        />
        <span className="position-absolute" style={{ left: "10px", top: "50%", transform: "translateY(-50%)" }}>
          <FontAwesomeIcon icon={faSearch} />
        </span>
      </div>
    </div>
  </div>
</div>


            <br/>
            <Row>
            {employeesDetails.length === 0 ? (
                    <div className="text-center mb-2">No Data Avilable</div>
                  ) : (
            employeesDetails.map((accd) => (
              
            <Col key={accd.id} md={4} className="mb-3">
<div
    className="card card-raised h-100"
    onClick={() => openProfileModal(accd.userid)}
    style={{ cursor: "pointer" }}
    title="View Details"
  >
    <div className="card-body">
      <Card>
        <Card.Body>
             
                <div className="card-title text-center">
        {accd.employeeProfileImage?.image && accd.employeeProfileImage?.image ? (
          <img 
            src={`${accd.employeeProfileImage?.imageMeta},${accd.employeeProfileImage?.image}`} 
            alt="User Profile" 
            style={{ width: '100px', height: '100px', borderRadius: '50%' }} 
          />
        ) : (
          <FaRegUserCircle />
        )}
      </div>
                   <div className="card-title text-center">
 
                <Card.Text>{accd.name} {accd.lastname}</Card.Text>
                </div>
                  <br/>
                  <Card.Text>Email: {accd.email}</Card.Text>
                  <Card.Text>Phone Number: {accd.phoneno}</Card.Text>
                  <Card.Text>Company Code: {accd.companycode}</Card.Text>
                  {/* <Card.Text>Designation: {accd.designation}</Card.Text>
                  <Card.Text>Date of Joining: {accd.dateOfJoining}</Card.Text> */}
               <Card.Text className="card-footer bg-light d-flex align-items-center justify-content-between">
  <div className="form-check">
  <input
  type="checkbox"
  className="form-check-input"
  id={`approveCheckbox-${accd.userid}`}
  checked={isApproved}
  onClick={(e) => handleApprovalChange(e, accd.userid)}
/>

    <label className="form-check-label" htmlFor="approveCheckbox">
      Approve
    </label>
  </div>
</Card.Text>

               
                </Card.Body>
              
              </Card>
              </div>
              </div>
             
              </Col>
              
            ))
          )}
                </Row>
                <div className="d-flex justify-content-center">
                <Pagination>
                  <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                  <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                  {renderPageNumbers()}
                  <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
                  <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
                </Pagination>
              </div>
            </div>
          </div>

{isModalOpen && (
<EmployeeDetailsModal 
        isOpen={isModalOpen}
        onRequestClose={handleCloseProfileModal}
        userid={selectedUserid} 
      />
)}
           
        </div>
      </div>
    );
}

export default EmployeeAccountApproval;